
import { Component, Prop } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import { hslColorFromName } from "@/utils/hslColorFromName";

import GetRelativeRouteNameMixin from "@/mixins/route/GetRelativeRouteNameMixin.vue";
import TableListChipNew from "@/components/table/table-list-chip-new.vue";
import CardBodyItem from "@/components/card/CardBodyItem.vue";
import Card from "@/components/card/Card.vue";
import CardInfoChip from "@/components/card/CardInfoChip.vue";
import CollapsibleDescription from "@/components/common/CollapsibleDescription.vue";
import CircleWithInitials from "@/components/card/CircleWithInitials.vue";
import UIButton from "@/components/button/ui-button.vue";
import ColorIconContainer from "@/components/icons/ColorIconContainer.vue";
import ChatIcon from "@/components/icons/ChatIcon.vue";
import ViewIcon from "@/components/icons/ViewIcon.vue";
import ViewIconBlack from "@/components/icons/ViewIconBlack.vue";
import CreateGroupConversationModal from "@/components/inbox/CreateGroupConversationModal.vue";
import ConversationUserDataForModal from "@/entities/ConversationUserDataForModal";
import ActivityHoursUnconfirmedAlert from "@/components/projects/activities/ActivityHoursUnconfirmedAlert.vue";
import ProjectActivitySmallCard from "@/components/companyProjects/ProjectActivitySmallCard.vue";
import RouteNames from "@/entities/RouteNames";
import visitTypeDisplayMap from "@/entities/VisitType";
import Roles from "@/entities/Roles";
import getFullNameOrPlaceholder from "@/helpers/getFullNameOrPlaceholder";
import LocationIcon from "@/components/icons/LocationIconGrayNew.vue";
import CalendarIcon from "@/components/icons/CalendarListHover.vue";
import ClockIcon from "@/components/icons/ClockIconGray.vue";
import HouseIcon from "@/components/icons/HouseGrayIcon.vue";
import CheckIcon from "@/components/icons/Checkmark.vue";
import CheckMarkBlack from "@/components/icons/CheckMarkBlack.vue";
import XIcon from "@/components/icons/XIcon.vue";
import { Project, Project_Activity, User } from "@/generated/graphql";
import ItemChipsWithMore from "@/components/common/ItemChipsWithMore.vue";
import ClientVisitsModal from "@/components/projects/ClientVisitsModal.vue";
import RouteParams from "@/entities/RouteParams";
import ActionSection from "../card/ActionSection.vue";
import MessageIcon from "../icons/MessageIcon.vue";
import BadgeColor from "@/entities/BadgeColor";
import Badge from "../common/BadgeNew.vue";
import moment from "moment";
import ClientVisitsConfirmModal from "./ClientVisitsConfirmModal.vue";

interface IActionDefault {
  leftTitle: string;
  leftValue: number | string;
  rightTitle: string;
  rightValue: number | string;
}

interface IActionError {
  title: string;
  description: number | string;
  actionButton: string;
}

interface IActionSection {
  state: boolean;
  default: IActionDefault;
  // error: IActionError;
}

enum MODE {
  ACCEPT = "ACCEPT",
  REJECT = "REJECT",
}

@Component({
  components: {
    TableListChipNew,
    CardBodyItem,
    ViewIconBlack,
    LocationIcon,
    XIcon,
    CalendarIcon,
    HouseIcon,
    ClockIcon,
    CheckIcon,
    CheckMarkBlack,
    Card,
    CardInfoChip,
    CircleWithInitials,
    UIButton,
    CollapsibleDescription,
    ColorIconContainer,
    ChatIcon,
    ViewIcon,
    MessageIcon,
    CreateGroupConversationModal,
    ActivityHoursUnconfirmedAlert,
    ItemChipsWithMore,
    ProjectActivitySmallCard,
    ActionSection,
    ClientVisitsModal,
    ClientVisitsConfirmModal,
    Badge,
  },
})
export default class ClientsVisitsCard extends mixins(
  GetRelativeRouteNameMixin
) {
  @Prop({ type: Object, required: true }) readonly client!: Project;
  @Prop({ type: String, default: undefined }) readonly companyId!: string;
  @Prop({ type: String, default: RouteNames.PROJECT_ACTIVITY })
  readonly projectDetailsRoute!: RouteNames;
  @Prop({ type: Boolean, default: false }) readonly canEdit!: boolean;
  @Prop({ type: Boolean, default: false }) readonly hideDescription!: boolean;
  @Prop({ type: Boolean, default: false })
  readonly alertUncofirmedActivities!: boolean;
  @Prop({ type: Boolean, default: false }) readonly value!: boolean;
  @Prop({ type: Object, required: true }) readonly currentUser!: User;
  @Prop({ type: Boolean, default: false })
  readonly isWithActivities!: boolean;

  selectedVisits: Project_Activity[] = [];

  BadgeColor: typeof BadgeColor = BadgeColor;
  showActivities = false;
  dialog: boolean = false;
  activityModalOpened = false;
  newConversationDialog: boolean = false;
  toggleVisitsAcceptModal = false;
  currentMode: MODE = MODE.ACCEPT;
  toggleVisitsConfirmModal = false;
  projectStatus = {
    UPCOMING: "UPCOMING",
    NEW_VISITS: "NEW_VISITS",
    NO_UPCOMING: "NO_UPCOMING",
  };

  // get getProjectStatus(): string {

  //     for (let i = 0; i < this.client.project_activities.length; i++) {
  //         const activity = this.client.project_activities[i];
  //         if (!activity.accepted && !activity.rejected) {
  //             return this.clientStatus.NEW_VISITS
  //         }
  //     }
  //     for (let i = 0; i < this.client.project_activities.length; i++) {
  //         const activity = this.client.project_activities[i];
  //         const currentDate = new Date()
  //         const shiftStartDate = new Date(activity.start_date)
  //         if (shiftStartDate > currentDate) {
  //             return this.clientStatus.UPCOMING
  //         }
  //     }
  //     return this.clientStatus.NO_UPCOMING
  // }

  get typeOfWork(): string {
    const items = this.client.support_type;
    return items?.join(", ") || "n/a";
  }

  get initial(): string {
    const firstName = this.client.manager.user?.given_name;
    const lastName = this.client.manager.user?.family_name;

    if (!firstName && !lastName) {
      return "";
    }

    const givenName = firstName ? firstName.trimLeft()[0] : "";
    const familyName = lastName ? lastName.trimLeft()[0] : "";
    return `${givenName}${familyName}`;
  }
  getStyleClass(visit) {
    if (visit.accepted === true) {
      return "greenBG";
    } else {
      return "blueBG";
    }
  }
  typeOfVisit(visit): string {
    return this.getVisitType(visit.type_of_visit);
  }

  getVisitType(type: string | undefined): string {
    if (!type) return "n/a";
    return (
      visitTypeDisplayMap[type] ||
      type
        .replace(/_/g, " ")
        .toLowerCase()
        .replace(/(^\w|\s\w)/g, (m) => m.toUpperCase())
    );
  }

  get bgStyle(): object {
    return {
      background: hslColorFromName(this.initial || ""),
    };
  }

    age(clientDob): number | string {
  if (!clientDob) {
    return "n/a";
  }

  const dob = new Date(clientDob);
  const today = new Date();
  let age = today.getFullYear() - dob.getFullYear();
  const monthDiff = today.getMonth() - dob.getMonth();

  // Adjust age if the birth date hasn’t occurred yet this year
  if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < dob.getDate())) {
    age--;
  }

  return age;
}

  get showActivitiesBtnTitle(): string {
    return this.showActivities ? "Hide Tasks" : "Show Tasks";
  }

  get projectDetails(): RouteParams<{ id: string }> {
    return {
      name: RouteNames.PROJECT_DETAILS,
      params: {
        id: this.client.id,
      },
    };
  }

  get projectManager(): string {
    const givenName = this.client?.manager?.user.given_name;
    const familyName = this.client?.manager?.user.family_name;
    return getFullNameOrPlaceholder(givenName, familyName);
  }

  get hasUnconfirmedHours(): boolean {
    if (!this.alertUncofirmedActivities || !this.client?.project_activities) {
      return false;
    }

    return this.client.project_activities.some(
      ({ requested_hours, confirmed_hours }) =>
        Boolean(requested_hours) && !confirmed_hours
    );
  }

  get title(): string {
    return this.client.name || " - ";
  }

  get canEditProject(): boolean {
    return this.canEdit && !!this.companyId && !this.client.completed;
  }

  // get location(): string {
  // 	return getLocationInfo(this.client);
  // }

  get createdDate(): string {
    if (this.client.created_at) {
      return this.formattedDate(this.client.created_at);
    }
    return "";
  }

  get startDate(): string {
    return this.formattedDate(this.client.start_date);
  }

  get endDate(): string {
    return this.formattedDate(this.client.end_date);
  }

  get activities(): Project_Activity[] {
    return this.client.project_activities;
  }

  get totalActivities(): number | undefined {
    const getActiveTasks = this.client.project_activities.filter(
      (item) => !item.deleted
    );
    const activities = getActiveTasks.length;
    return activities;
    // return `${activities} ${activities === 1 ? 'Task' : 'Tasks'}`;
  }

  get hasParticipants(): boolean {
    return this.clientUsers.length > 0;
  }

  get clientUsers(): ConversationUserDataForModal[] {
    const { project_activities: activities } = this.client;
    const manager = this.client.manager?.user;

    if (!activities.length && !manager) {
      return [];
    }

    const uniqueIds = new Set();

    const uniqueUsers = activities.reduce(
      (arr: ConversationUserDataForModal[], { contractor }) => {
        const user = contractor?.user;
        if (!user) {
          return arr;
        }
        const currentStepContractors: ConversationUserDataForModal[] = [];

        if (!uniqueIds.has(user.id)) {
          currentStepContractors.push({
            userId: user.id,
            avatar: user.avatar,
            name: `${user.given_name} ${user.family_name}`,
          });
          uniqueIds.add(user.id);
        }

        return arr.concat(currentStepContractors);
      },
      []
    );

    if (!manager || this.currentUser.role === Roles.MANAGER) {
      return uniqueUsers;
    }

    return [
      ...uniqueUsers,
      {
        userId: manager.id,
        avatar: manager.avatar,
        name: `${manager.given_name} ${manager.family_name} (manager)`,
      },
    ];
  }

  get getActionSectionValues(): IActionSection {
    // use this function to get the values for the action section

    const offerdVisits = this.totalActivities;
    let assignedVisits = 0;
    this.client.project_activities.forEach((projectActivity) => {
      if (projectActivity.accepted) {
        assignedVisits++;
      }
    });

    const actionSectionResult: IActionSection = {
      state: false,
      default: {
        leftTitle: "Offered Visits",
        leftValue: offerdVisits,
        rightTitle: "Assigned visits",
        rightValue: assignedVisits,
      },
    };
    return actionSectionResult;
  }

  get nearestVisits(): Project_Activity {
    const today: any = new Date();
    let nearestDate = null;
    let nearestObject: Project_Activity | null = null;

    this.client.project_activities.forEach((obj) => {
      const objDate: any = new Date(obj.start_date);
      if (
        !nearestDate ||
        Math.abs(objDate - today) < Math.abs(nearestDate - today)
      ) {
        nearestDate = objDate;
        nearestObject = obj;
      }
    });

    return nearestObject;
  }

  formattedDate(date: string): string {
    if (date) {
      return new Date(date).toLocaleDateString("en-ca", {
        year: "numeric",
        month: "short",
        day: "numeric",
      });
    } else {
      return "n/a";
    }
  }

  formattedTime(dateTime: string): string {
    if (!dateTime) return "n/a";
  
  try {
    const time = this.$moment(dateTime)
    if (!time.isValid()) return "Invalid Time";
    
    return time.minutes() > 0 
      ? time.format("h:mm A")  // Show minutes (e.g., "12:30 PM")
      : time.format("h A");    // Hide minutes when zero (e.g., "12 PM")
  } catch {
    return "Invalid Time";
  }
  }

  onSubmitVisits(selectedVisits: Project_Activity[]) {
    this.toggleVisitsAcceptModal = false;
    this.selectedVisits = selectedVisits;
    this.updateVisitsConfirmModal(true);
  }

  updateVisitsConfirmModal(status: boolean) {
    this.toggleVisitsConfirmModal = status;
  }

  handleShowActivities() {
    this.showActivities = !this.showActivities;
  }
  handleEditClick(): void {
    this.dialog = true;
  }

  openActivityModal(): void {
    this.activityModalOpened = true;
  }

  onActivityListItemAdded(): void {
    this.$router.push({
      name: this.projectDetailsRoute,
      params: { id: this.client.id },
    });
  }

  groupMessage(): void {
    this.newConversationDialog = true;
  }

  message(): void {
    this.$router.push({
      name: RouteNames.INBOX,
      query: {
        recipientUserId: this.client.manager.user.id,
      },
    });
  }

  updateVisitsAcceptModal(status: boolean) {
    if (status) {
      this.currentMode = MODE.ACCEPT;
    }
    this.toggleVisitsAcceptModal = status;
  }

  updateVisitsDeclineModal(status: boolean) {
    if (status) {
      this.currentMode = MODE.REJECT;
    }
    this.toggleVisitsAcceptModal = status;
  }
}
